import React from 'react'
import { IconAlertCircle } from '@tabler/icons-react'
import { isEmpty } from 'lodash'
import classNames from 'classnames'
import pluralize from 'pluralize'

import { Loader } from '@/components/loaders/Loader'
import { Banner } from '@/components/banners/Banner'
import { Button } from '@/components/buttons/Button'

export const MassPlaybookUpdateWarningBanner = () => (
  <Banner
    caution
    data-testid="mass-playbook-edit-banner"
    header="Proceed with Caution"
    icon={<IconAlertCircle />}
    shrunkHeight
  >
    {`Once published, the save as draft step will be skipped, and these text changes and other
      settings will apply to all selected Playbooks.`}
  </Banner>
)

export const LoadingPlaybooks = ({ loading, isEnabled, isUpdate }) =>
  loading &&
  isEnabled && (
    <div className="playbooks-loading-suggestions">
      <Loader centered />
      <div>
        {isUpdate
          ? 'Searching for similar content across your Playbooks...'
          : 'Searching for other Playbooks...'}
      </div>
    </div>
  )

export const SelectionActions = ({ isOnTop, selection, allSelected, matches, handleSelectAll }) => {
  const allSelectedText =
    selection.length === 1 ? `All items selected.` : `All ${selection.length} items selected.`
  const countText = allSelected
    ? allSelectedText
    : `${selection.length} ${pluralize('item', selection.length)} selected.`
  return (
    <div className="flex-center">
      <div
        className={classNames(
          'flex-align-center gap full-width',
          { mtl: !isOnTop },
          { mb: isOnTop },
          { 'preview-content-column': !isOnTop }
        )}
      >
        <div className="flex-item ">{`${matches.length} ${pluralize('result')} found`}</div>
        {!isEmpty(matches) && (
          <>
            <div className="bold">{countText}</div>
            <Button text data-testid="select-all-button" onClick={handleSelectAll}>
              {matches.length === selection.length ? 'Deselect all' : 'Select all'}
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
